import { CookieService } from 'ngx-cookie-service';
import { ApiEnvironmentService } from '../app-initializer/api-environment';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SSORedirectHelper } from '../helpers';
import { map, take, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class AuthService {

  // a reactive boolean that returns if a user is authenticated
  public isAuthenticated$ = new BehaviorSubject<boolean>(this.checkForExistingUser());
  public newAuthToken = "";

  constructor(private cookieService: CookieService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: any,
    private apiEnvironmentService: ApiEnvironmentService) {
  }

  public refreshJwtToken() {
    return this.http.get(`${this.apiEnvironmentService.baseAdminUrl}/user/login`)
    .pipe(
      take(1),
      map((token) => {
        this.newAuthToken = token['token'];
        return this.newAuthToken;
      })
    );
  }

  public login() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = this.getSamlSignInUrl(window.location.href);
    }
  }

  public logout(returnHome?) {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = this.getSamlSignOutUrl((returnHome ? window.location.hostname : window.location.href), window.location.hostname);
      this.cookieService.delete(environment.jwtCookieName);
    }
  }

  public getAuthToken() {
    if (this.cookieService.check(environment.jwtCookieName)) {
      return this.cookieService.get(environment.jwtCookieName);
    }

    return '';
  }

  public getSamlSignInUrl(redirectUrl: string) {
    if (isPlatformBrowser(this.platformId)) {
      return SSORedirectHelper.withReturnUrl(this.apiEnvironmentService.baseAccountUrl + '/login', redirectUrl, '');
    } else {
      return '';
    }
  }

  public getSamlSignOutUrl(redirectUrl: string, hostName: string) {
    if (isPlatformBrowser(this.platformId)) {
      return SSORedirectHelper.withReturnUrl(`${this.apiEnvironmentService.baseAccountUrl}/logout`, redirectUrl.includes('dashboard') ? `${hostName}` : redirectUrl, '');
    } else {
      return '';
    }
  }

  public getSsoSignInUrl(redirectUrl: string) {
    if (isPlatformBrowser(this.platformId)) {
      return SSORedirectHelper.withReturnUrl(`${this.apiEnvironmentService.baseAccountUrl}/login`, redirectUrl, '');
    } else {
      return '';
    }
  }

  private checkForExistingUser() {
    const authUser = this.getAuthToken();
    if (authUser !== '') {
      return true;
    } else {
      return false;
    }
  }
}
